import { DetailHero } from '@/components/common/DetailHero';
import { DetailLinesTable, type DetailLineColumn } from '@/components/common/DetailLinesTable';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { TAKA_SYMBOL } from '@/constants/app.constants';
import { formatNumber } from '@/utils/number';
import type { MpBudgetProject, MpSummaryRow } from '../types/marketPromotion.types';

const BUDGET_PROJECT_COLUMNS: DetailLineColumn<MpBudgetProject>[] = [
  { header: 'Donation Project', render: (project) => project.name },
  {
    header: `Budget (${TAKA_SYMBOL})`,
    isNumeric: true,
    render: (project) => formatNumber(project.budgetAmount),
  },
];

interface BudgetProjectsDialogProps {
  holder: MpSummaryRow | null;
  open: boolean;
  onClose: () => void;
}

export function BudgetProjectsDialog({ holder, open, onClose }: BudgetProjectsDialogProps) {
  return (
    <Dialog
      open={open && holder !== null}
      onOpenChange={(open) => {
        if (!open) onClose();
      }}
    >
      <DialogContent className="max-h-[85vh] overflow-auto sm:max-w-xl">
        <DialogHeader>
          <DialogTitle>Budget by Project</DialogTitle>
        </DialogHeader>
        {holder === null ? null : (
          <div className="flex flex-col gap-5">
            <DetailHero
              heading={<span className="text-lg font-semibold tracking-tight">{holder.name}</span>}
              subline={<BudgetHolderFacts holder={holder} />}
              amountLabel="Total Budget"
              amount={holder.budgetAmount}
              amountNote={null}
            />
            <DetailLinesTable
              title="Donation Projects"
              lines={holder.budgetProjects}
              columns={BUDGET_PROJECT_COLUMNS}
              getLineKey={(project) => project.promoItemId}
            />
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}

function BudgetHolderFacts({ holder }: { holder: MpSummaryRow }) {
  const facts = [holder.designationName, holder.hrEmpId, holder.userMobile].filter(
    (fact): fact is string => Boolean(fact),
  );
  if (facts.length === 0) return null;

  return <span className="text-xs text-muted-foreground tabular-nums">{facts.join(' · ')}</span>;
}
